import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import matchingPairsCtActions from 'redux/actions/matching_pairs_ct_actions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import PreviewModal from 'views/slides/activities/matching_pairs/creation_tool/modals/preview/preview_modal'
import containerSelector from 'redux/selectors/matching_pairs/creation_tool_preview_selector'

class PreviewModalContainer extends PureComponent {

	render() {
		return (
			<PreviewModal
				closeHandler={this.props.actions.closeModal}
				activityData={this.props.activityData}
			/>
		)
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeModal: matchingPairsCtActions.closePreview,
	}, dispatch)
}

function mapStateToProps(state) {
	return containerSelector(state)
}

export default connect(mapStateToProps, mapDispatchToProps)(PreviewModalContainer)
